import { gsap } from 'gsap/all'
import { store } from '../../../src/js/core/store.js'

export class Button {
  constructor (element) {
    this.button = element
    this.wrap = this.button.querySelector('.js-button-wrap')
    this.mouseover = false

    if (!store.isDevice) {
      this.init()
    }
  }

  init = () => {
    this.addBackground()
    this.setDefaults()
    this.createTimelines()
    this.bindEvents()
  }

  addBackground = () => {
    this.background = document.createElement('div')
    this.background.className = 'button__background js-button-background'
    this.background.style.position = 'absolute'
    this.background.style.top = 0
    this.background.style.right = 0
    this.background.style.bottom = 0
    this.background.style.left = 0

    if (this.button.classList.contains('button--white')) {
      this.color = '#052827'
      this.hoverColor = '#FFF'
    } else {
      this.color = '#FFF'
      this.hoverColor = '#052827'
    }

    this.button.appendChild(this.background)
  }

  setDefaults = () => {
    gsap.set(this.background, { y: '101%' })
  }

  createTimelines = () => {
    this.createTimelineEnter()
    this.createTimelineLeave()
  }

  createTimelineEnter = () => {
    this.timelineEnter = new gsap.timeline({
      paused: true,
      onStart: () => {
        this.timelinePlaying = true
      },
      onComplete: () => {
        this.timelinePlaying = false

        if (!this.mouseover) {
          this.timelineLeave.restart()
        }
      }
    })

    this.timelineEnter
      .to(this.wrap, 0.2, { y: -6, opacity: 0, ease: 'power2.in'}, 'a')
      .set(this.wrap, { y: 6, color: this.hoverColor })
      .to(this.wrap, 0.2, { y: 0, opacity: 1, ease: 'power2.out' })
      .to(this.background, 0.4, { y: 0, ease: 'power2.inOut' }, 'a')
  }

  createTimelineLeave = () => {
    this.timelineLeave = new gsap.timeline({
      paused: true,
      onStart: () => {
        this.timelinePlaying = true
      },
      onComplete: () => {
        this.timelinePlaying = false
        if (this.mouseover) {
          this.timelineEnter.restart()
        }
      }
    })

    this.timelineLeave
      .to(this.wrap, 0.2, { y: -6, opacity: 0, ease: 'power2.in' }, 'a')
      .set(this.wrap, { y: 6, color: this.color })
      .to(this.wrap, 0.2, { y: 0, opacity: 1, ease: 'power2.out' })
      .to(this.background, 0.4, { y: '-101%', ease: 'power2.inOut' }, 'a')
  }

  bindEvents = () => {
    this.button.addEventListener('mouseenter', this.handleEnter)
    this.button.addEventListener('mouseleave', this.handleLeave)
  }

  handleEnter = () => {
    this.mouseover = true

    if (!this.timelinePlaying) {
      this.timelineEnter.restart()
    }
  }

  handleLeave = () => {
    this.mouseover = false

    if (!this.timelinePlaying) {
      this.timelineLeave.restart()
    }
  }
}
